import { action, observable, makeObservable } from "mobx";

export class SwayyDashboardStore {
  initializedAt: Date;

  constructor() {
    this.initializedAt = new Date();

    makeObservable(this, {
      initializedAt: observable,
      reset: action,
    });
  }

  reset = () => {
    this.initializedAt = new Date();
  };
}
